import { useQuery } from '@tanstack/react-query'
import { accessControlApi } from '../api/access-control.client'

export const roleUsersQueryKey = (roleId: string) => [
  'access-control',
  'roles',
  roleId,
  'users',
]

export function useRoleUsersQuery(roleId: string) {
  return useQuery({
    queryKey: roleUsersQueryKey(roleId),
    queryFn: () => accessControlApi.listRoleUsers(roleId),
    enabled: !!roleId,
    retry: false,
    refetchOnWindowFocus: false,
  })
}
